<form class="flex-column" [formGroup]="userForm">
  <div class="code-block">
    @if (userForm.controls['email']) {
      <ng-container formGroupName='email'>
        @if (codeWasSent$ | async; as wasSent) {
          <div class="header-block">
            <button (click)="backToEmail()" class="back-btn"  (mouseenter)="arrowMouseEnter()" (mouseleave)="arrowMouseLeave()">
              @if(arrowFieldState()){
                <img
                  src="/assets/images/login/arrow-small.svg"
                  class="dropdown-arrow"
                  [class.open]="regionPanelIsOpen"
                  alt="arrow"
                />
              }@else {
                <img
                  src="/assets/images/login/arrow.svg"
                  class="dropdown-arrow"
                  [class.open]="regionPanelIsOpen"
                  alt="arrow"
                />
              }
            </button>
            <h2 class="title h1">ПОДТВЕРДИТЕ ПОЧТУ</h2>
          </div>
          <h5 class="text-3 text-sended-code">
            На почту {{ userForm.get("email.email")?.value }} отправлен проверочный
            код
          </h5>
          <div class="login-block">
            <div class="some-input-and-label">
              <input
                [placeholder]="isFocusedEmailCode ? '' : 'Введите код'"
                (focus)="isFocusedEmailCode = true"
                (blur)="isFocusedEmailCode = false"
                [formControlName]="fields['email'].fields[1].name"
                class="text-form code"
                [id]="fields['email'].fields[1].name"
                [type]="fields['email'].fields[1].name === 'code' ? 'number' : 'text'"
                mask="0000"
                type="number"
                (input)="errorMessage.set(null)"
                [class]="{'input-error': getErrorType(fields['email'].fields[1].name, 'email') || errorMessage()}"
              />
              @if (getErrorType(fields['email'].fields[1].name, 'email')) {
                <p class="text-error">
                  {{ getErrorType(fields['email'].fields[1].name, 'email') }}
                </p>
              } @else if (errorMessage()) {
                <p class="text-error">
                  {{ errorMessage() }}
                </p>
              }
            </div>

            <app-button
              (click)="cofirmEmailWithCode()"
              [disabled]="userForm.get('email.code')?.invalid ||   !!errorMessage()"
              [title]="'Подтвердить'"
            >
            </app-button>
            @if (timerStatus()) {
              <button class="get-code-btn" disabled>
         <span class="text-1 resend-code">Повторная отправка будет доступна через <br />
            (@if (timer().hoursLeft) {
             {{ timer().hoursLeft | number: '2.0' }}:
           }
           {{ timer().minutesLeft | number: '2.0' }}:
           {{ timer().secondsLeft | number: '2.0' }})
         </span>
              </button>
            }
            @if(!timerStatus()){
              <app-button
                (click)="addEmailAndRequestConfirm(true)"
                [variant]="'outline'"
                [disabled]="timer()!.secondsLeft > 0"
                [title]="'Отправить код повторно'">
              </app-button>
            }
          </div>
        } @else {
          <p class="h1 black uppercase text-center">
            Введите почту
          </p>
          <div class="login-block">
            <div class="some-input-and-label">
              <input
                formControlName="email"
                class="text-form"
                noWhitespace
                [placeholder]="isFocusedEmail ? '' : 'Введите почту'"
                (focus)="isFocusedEmail = true"
                (blur)="isFocusedEmail = false"
                (input)="inputEmail()"
                [class]="{ 'input-error': getErrorType(fields['email'].fields[0].name, 'email') || errorMessage()}"
              />
              @if (getErrorType(fields['email'].fields[0].name, 'email')) {
                <p class="text-error">
                  {{ getErrorType(fields['email'].fields[0].name, 'email') }}
                </p>
              } @else if (errorMessage()) {
                <p class="text-error">
                  {{ errorMessage() }}
                </p>
              }
            </div>
            <app-button
              (click)="addEmailAndRequestConfirm()"
              [disabled]="(userForm.get('email.email')?.invalid   ||  !!errorMessage())"
              [title]="'Отправить код'">
            </app-button>
          </div>
        }
      </ng-container>
    } @else if (userForm.controls['photo']) {
      <ng-container formGroupName="photo">
        <p class="h2 black uppercase text-center">
          Для продолжения работы в системе<br/>
          заполните, пожалуйста, обязательные поля:
        </p>
        <div class="login-block">
          <div class="some-input-and-label">
            <label required class="h3" [for]="fields['photo'].fields[0].name">{{
                fields["photo"].fields[0].title
              }}</label>
            <input
              class="text-form"
              (change)="onFileChange($event)"
              [id]="fields['photo'].fields[0].name"
              type="file"
              accept=".png, .jpg, .jpeg, .pdf"
            />
            <p class="text-error">
              {{ getErrorType(fields["photo"].fields[0].name, "photo") }}
            </p>
          </div>
          @if(errorMessage()){
            <p  class="text-error">
              {{ errorMessage() }}
            </p>
          }
          <app-button
            (click)="uploadPhoto()"
            [disabled]="userForm.controls['photo'].invalid || !!this.errorMessage()"
            [title]="'Загрузить фото'"
          >
          </app-button>
        </div>
      </ng-container>
    } @else if (userForm.controls['personalInfo']) {
      <ng-container [formGroupName]="'personalInfo'">
        <p class="h1 black uppercase text-center">Заполните форму</p>
        <div class="login-block">
          @for (item of fields['personalInfo'].fields; track item.name) {
            @if (item.children) {
              <ng-container [formGroupName]="item.name">
                <div class="personalInfoInputs" style="display:flex; flex-direction:column; gap: 32px">
                  @for (child of item.children; track child.name) {
                    <div class="some-input-and-label">
                      <label [attr.required]="isRequired(child.name, 'fullName', 'personalInfo') ? '' : null" class="h3"
                             [for]="child.name">{{
                          child.title
                        }}</label>
                      <input
                        appOnlyLetters
                        [maxLength]="30"
                        [formControlName]="child.name"
                        class="text-form"
                        [id]="child.name"
                        type="text"
                        [class]="{ 'input-error': getErrorType(child.name, 'fullName', 'personalInfo')}"
                      />
                      @if (getErrorType(child.name, "fullName", "personalInfo")) {
                        <p class="text-error">
                          {{ getErrorType(child.name, "fullName", "personalInfo") }}
                        </p>
                      }
                    </div>
                  }
                </div>
              </ng-container>
            } @else {
              <div class="some-input-and-label">
                @if (item.name == 'region') {
                  <label [attr.required]="isRequired(item.name, 'personalInfo') ? '' : null" class="h3">Регион
                    проживания</label>
                  <mat-form-field appearance="fill" class="region-minimal">
                    <div class="input-wrapper" [class]="{
                            'input-error': getErrorType(item.name, 'personalInfo')
                        }">
                      <input
                        #regionInput
                        type="text"
                        matInput
                        [formControl]="regionSearchControl"
                        [matAutocomplete]="auto"
                        class="text-form region-input"
                        (focus)="onRegionInputFocus()"
                        (blur)="regionPanelBlur()"
                        [class]="{'input-error': getErrorType(item.name, 'personalInfo')}"/>
                    </div>
                    <img
                      src="/assets/images/login/arrow.svg"
                      class="dropdown-arrow"
                      [class.open]="regionPanelIsOpen"
                      alt="arrow"
                    />

                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayRegion"
                      (opened)="regionPanelIsOpen = true"
                      (closed)="regionPanelIsOpen = false"
                      (optionSelected)="onRegionSelected($event, item.name)">
                      @if (filteredRegions.length > 0) {
                        @for (option of filteredRegions; track option) {
                          <mat-option [value]="option">
                            {{ option.title }}
                          </mat-option>
                        }
                      } @else {
                        <ng-template >
                          <ng-template >
                            <mat-option disabled>Регион не найден</mat-option>
                          </ng-template>
                        </ng-template>
                      }
                    </mat-autocomplete>
                  </mat-form-field>

                  @if (getErrorType(item.name, "personalInfo")) {
                    <p class="text-error">
                      {{ getErrorType(item.name, "personalInfo") }}
                    </p>
                  }
                } @else if (item.name == 'birth_date') {
                  <label [attr.required]="isRequired( item.name, 'personalInfo') ? '' : null" class="h3"
                         [for]="item.name">{{ item.title }}</label>
                  <input
                    [formControlName]="item.name"
                    class="text-form"
                    placeholder="__.__.____"
                    [id]="item.name"
                    type="text"
                    validator-date="[0-9]"
                    [class]="{
                            'input-error': getErrorType(item.name, 'personalInfo')
                        }"
                  />
                  @if (getErrorType(item.name, "personalInfo")) {
                    <p class="text-error">
                      {{ getErrorType(item.name, "personalInfo") }}
                    </p>
                  }
                } @else {
                  <label [attr.required]="isRequired(item.name, 'personalInfo') ? '' : null" class="h3"
                         [for]="item.name">{{ item.title }}</label>
                  <input
                    [formControlName]="item.name"
                    class="text-form"
                    [id]="item.name"
                    type="text"
                    [class]="{
                            'input-error': getErrorType(item.name, 'personalInfo')
                        }"
                  />
                  <p class="text-error">
                    {{ getErrorType(item.name, "personalInfo") }}
                  </p>
                }
              </div>
            }
          }
          @if(errorMessage()){
            <p  class="text-error">
              {{ errorMessage() }}
            </p>
          }
          <app-button
            (click)="updateUserData()"
            [disabled]="userForm.controls['personalInfo'].invalid ||  !!this.errorMessage()"
            [title]="'Сохранить'"
          >
          </app-button>
        </div>
      </ng-container>
    } @else if (userForm.controls['password']) {
      <ng-container formGroupName="password">
        <p class="h2 black uppercase text-center">
          Для продолжения работы в системе<br/>
          заполните, пожалуйста, обязательные поля:
        </p>
        <div class="login-block">
          @for (item of fields['password'].fields; track item.name) {
            <div class="some-input-and-label">
              <label [attr.required]="isRequired(item.name, 'personalInfo') ? '' : null" class="h3"  [for]="item.name">{{ item.title }}</label>
              <input
                class="text-form"
                (change)="onFileChange($event)"
                [formControlName]="item.name"
                [id]="item.name"
                [class]="{'input-error': getErrorType(item.name, 'personalInfo')}"
              />
              @if (item.name === 'repeatPassword') {
                @if(userForm.get('password.repeatPassword')?.touched && userForm.get('password.repeatPassword')?.value !== userForm.get('password.password')?.value){
                  <p class="text-error">Пароли не совпадают</p>
                }
              } @else {
                <p class="text-error">{{ getErrorType(item.name, "password") }}</p>
              }
              @if(errorMessage()){
                <p  class="text-error">
                  {{ errorMessage() }}
                </p>
              }
            </div>
          }
          <app-button
            (click)="addPassword()"
            [disabled]="userForm.get('password')?.invalid || !!errorMessage()"
            [title]="'Сохранить'"
          >
          </app-button>
        </div>
      </ng-container>
    }
  </div>
</form>
